import { getChatLocale } from './get-chat-locale';
import { isManulifeMMHNCompany } from 'globals/manulife';

//ASYNC_CHAT_TODO: In future the tenancy lookup should return the correct Dynamics instance
/**
 *
 * @param widgetInstanceId
 * @returns the correct omnichannel configuration from the environment variables dependend on the users locale
 */
export const getOmnichannelChatConfig = (widgetInstanceId = 'widget1') => {
  const { firstLocalePart, secondLocalePart } = getChatLocale();
  const configKey = isManulifeMMHNCompany() ? 'manulife' : 'default';

  const config =
    window.WAM.ENV.ccsChatEndpoints[firstLocalePart][secondLocalePart][
      configKey
    ];

  config.widgetInstanceId = widgetInstanceId;

  return config;
};
